module.exports = __webpack_public_path__ + "static/media/funnelcake.e3f80f07.jpg";